import {Badge, Group, Paper, Stack, Title} from '@mantine/core'
import type {ReactNode} from 'react'

import type {JobEntrySectionId} from './job-entry-logic'

type JobEntrySectionProps = {
    id: JobEntrySectionId | 'notes'
    title: string
    errorCount: number
    children: ReactNode
}

export function JobEntrySection({id, title, errorCount, children}: JobEntrySectionProps) {
    return (
        <Paper withBorder p="md" radius="md" id={`job-entry-${id}`} component="section">
            <Stack gap="md">
                <Group justify="space-between">
                    <Title order={3}>{title}</Title>
                    {errorCount > 0 ? (
                        <Badge color="red" variant="light">
                            {errorCount === 1 ? '1 error' : `${errorCount} errors`}
                        </Badge>
                    ) : null}
                </Group>
                {children}
            </Stack>
        </Paper>
    )
}
